import { render, staticRenderFns } from "./PutDetailNbhd.vue?vue&type=template&id=4471944e&scoped=true&lang=pug&"
import script from "./PutDetailNbhd.vue?vue&type=script&lang=js&"
export * from "./PutDetailNbhd.vue?vue&type=script&lang=js&"
import style0 from "./PutDetailNbhd.vue?vue&type=style&index=0&id=4471944e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4471944e",
  null
  
)

export default component.exports